const headers = {
  name: "About",
  navigate: {
    path: [
      {
        name: "About",
        path: "/app/about",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
